import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { Users, Heart, TreeDeciduous, GitMerge, Network, History, UserPlus, Orbit } from 'lucide-react';
const SYSTEMIC_ICONS = [Users, Heart, TreeDeciduous, GitMerge, Network, History, UserPlus, Orbit];
export function HeroReikiIcons() {
  const icons = useMemo(() => {
    return Array.from({
      length: 10
    }).map((_, i) => ({
      id: i,
      Icon: SYSTEMIC_ICONS[i % SYSTEMIC_ICONS.length],
      top: `${Math.random() * 80 + 10}%`,
      left: `${Math.random() * 80 + 10}%`,
      size: Math.random() * 50 + 30,
      duration: Math.random() * 12 + 10,
      delay: Math.random() * 5,
      opacity: Math.random() * 0.08 + 0.04
    }));
  }, []);
  return <div className="absolute inset-0 pointer-events-none overflow-hidden z-0" data-id="element-237">
      {icons.map(({
      id,
      Icon,
      top,
      left,
      size,
      duration,
      delay,
      opacity
    }) => <motion.div key={id} className="text-blue-100" style={{
      position: 'absolute',
      top,
      left,
      width: size,
      height: size,
      opacity
    }} animate={{
      y: [0, -25, 0],
      x: [0, 15, 0],
      rotate: [0, 15, -15, 0],
      scale: [1, 1.15, 1]
    }} transition={{
      duration,
      repeat: Infinity,
      delay,
      ease: 'easeInOut'
    }} data-id="element-238">
          <Icon size={size} strokeWidth={0.5} data-id="element-239" />
        </motion.div>)}
    </div>;
}